import type { Editor as TinyMCE } from 'tinymce/tinymce';
import { SlashCommandMessages } from '../../../../../../../types';
import { EditorCommand } from '../../../../CurrentEditorContext';

type SlashCommandArgs = {
  editor: TinyMCE;
  openAiPrompt: () => void;
  messages: SlashCommandMessages;
};

export const SLASH_COMMANDS = 'slashcommands';
const SLASH_COMMAND_CHAR = '/';

export function addSlashCommandToEditor({ editor, openAiPrompt, messages }: SlashCommandArgs): void {
  const insertActions = [
    {
      text: messages.askOpenGov,
      icon: 'ai',
      action: function () {
        openAiPrompt();
      }
    },
    {
      text: messages.addImage,
      icon: 'image',
      action: function () {
        editor.execCommand(EditorCommand.MceImage);
      }
    },
    {
      text: messages.headingOne,
      icon: 'h1',
      action: function () {
        editor.execCommand(EditorCommand.MceInsertContent, false, '<h1>Heading 1</h1>');
        editor.selection.select(editor.selection.getNode());
      }
    },
    {
      text: messages.headingTwo,
      icon: 'h2',
      action: function () {
        editor.execCommand(EditorCommand.MceInsertContent, false, '<h2>Heading 2</h2>');
        editor.selection.select(editor.selection.getNode());
      }
    },
    {
      text: messages.headingThree,
      icon: 'h3',
      action: function () {
        editor.execCommand(EditorCommand.MceInsertContent, false, '<h3>Heading 3</h3>');
        editor.selection.select(editor.selection.getNode());
      }
    },
    {
      text: messages.bulletedList,
      icon: 'unordered-list',
      action: function () {
        editor.execCommand(EditorCommand.InsertUnorderedList, false);
      }
    },
    {
      text: messages.numberedList,
      icon: 'ordered-list',
      action: function () {
        editor.execCommand(EditorCommand.InsertOrderedList, false);
      }
    }
  ];

  // Register the slash commands autocompleter
  editor.ui.registry.addAutocompleter(SLASH_COMMANDS, {
    ch: SLASH_COMMAND_CHAR,
    minChars: 0,
    columns: 1,
    fetch: function (pattern) {
      const matchedActions = insertActions.filter(function (action) {
        return action.text.toLowerCase().indexOf(pattern.toLowerCase()) !== -1;
      });

      return new Promise((resolve) => {
        const results = matchedActions.map(function (action) {
          return {
            meta: action,
            text: action.text,
            icon: action.icon,
            value: action.text,
            type: 'autocompleteitem' as const
          };
        });

        resolve(results);
      });
    },
    onAction: function (autocompleteApi, rng, action, meta) {
      editor.selection.setRng(rng);
      // Some actions don't delete the "slash", so we delete all the slash
      // command content before performing the action
      editor.execCommand(EditorCommand.Delete);
      meta.action();
      autocompleteApi.hide();
    }
  });
}
